import { useEffect } from "react";
import { Form, Input, Select, Space } from "antd";
import { useSelector} from "react-redux";
import { LockOutlined } from "@ant-design/icons";

import { Options } from "../../../../../components";


import { REDUX as REDUX_UTIL} from "../../../../../services/util";

const { reduxStoreWrapper } = REDUX_UTIL;

const CompanyProfile = (props) => {
  const { form, isEditing } = props;

  const company = useSelector(reduxStoreWrapper("company.byCOID"));
  const user = useSelector(reduxStoreWrapper("user"));

  useEffect(() => {
    if (company) {
      const contactCode = company.pic ? company.pic.contact.slice(0, 3) : "";
      const contactNumber = company.pic ? company.pic.contact.slice(3) : "";
      form.setFieldsValue({
        ...company,
        pic: {
          ...company.pic,
          contactCode: contactCode,
          contactNumber: contactNumber,
        },
      });
    }
  }, [company]);

  return (
    <div style={{ maxWidth: "32rem" }}>
      <h1 style={{ padding: "1em" }}>Company Information</h1>
      <Form
        form={form}
        name="profileForm"
        layout="vertical"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Form.Item
            label="Company Name "
            name="name"
            rules={[{ required: true, message: "Please input your company name!" }]}
            style={{ width: "48%" }}
          >
            <Input placeholder="Enter your company name" disabled={!isEditing || user?.uroleid !== "A"} />
          </Form.Item>

          <Form.Item
            label="Registration Number"
            name="regis_number"
            rules={[
              { required: true, message: "Please input your registration number!" },
            ]}
            style={{ width: "48%" }}
          >
            <Input
              suffix={<LockOutlined />}
              placeholder="Enter your registration number"
              disabled={!isEditing || user?.uroleid !== "A"}
            />
          </Form.Item>
        </div>

        <Form.Item name={['address', 'mailing']} label="Mailing Address">
          <Input.TextArea disabled={!isEditing} />
        </Form.Item>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Form.Item
            label="Post Code "
            name={['address', 'postCode']}
            rules={[
              { required: true, message: "Please input your Post Code!" },
            ]}
            style={{ width: "30%" }}
          >
            <Input placeholder="Enter your post code" disabled={!isEditing} />
          </Form.Item>

          <Form.Item
            label="City"
            name={['address', 'city']}
            rules={[{ required: true, message: "Please input your City!" }]}
            style={{ width: "30%" }}
          >
            <Input
              placeholder="Enter your city"
              disabled={!isEditing}
            />
          </Form.Item>

          <Form.Item
            label="State"
            name={['address', 'state']}
            rules={[{ required: true, message: "Please input your state!" }]}
            style={{ width: "30%" }}
          >
            <Select
              placeholder="Enter your state"
              disabled={!isEditing}
              options={Options.stateList}
            />
          </Form.Item>
        </div>

        <h1 style={{ padding: "1em" }}>PIC Information</h1>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Form.Item
            label="PIC Name"
            name={['pic', 'name']}
            rules={[
              { required: true, message: "Please input your job position!" },
            ]}
            style={{ width: "30%" }}
          >
            <Input
              placeholder="Enter your job position"
              disabled={!isEditing}
            />
          </Form.Item>
          <Form.Item
            label="Contact"
            // name={['pic', 'contact']}
            rules={[
              { required: true, message: "Please input your contact number!" },
            ]}
            style={{ width: "20rem" }}
          >
            <Space.Compact>
              <Form.Item
                name={['pic', 'contactCode']}
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Please input your contact code!",
                  },
                ]}
              >
                <Input
                  style={{ width: "20%" }}
                  placeholder="Code"
                  disabled={!isEditing}
                />
              </Form.Item>
              <Form.Item
                name={['pic', 'contactNumber']}
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Please input your contact number!",
                  },
                ]}
              >
                <Input
                  suffix={isEditing ? <LockOutlined /> : null}
                  style={{ width: "80%" }}
                  placeholder="Number"
                  disabled={!isEditing}
                />
              </Form.Item>
            </Space.Compact>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default CompanyProfile;
